import { createClient } from '@supabase/supabase-js';
const supabase = createClient(
  'https://adzuiohplufoayvhjtfv.supabase.co',
  'sb_publishable_fJi666MabPwqtXxSGLSE0g_5hVTuUYB'
);
if (process.env.NODE_ENV !== 'production') window.supabase = supabase;
export { supabase };